import { Card, Grid, List, CardHeader, Divider, Typography, CardContent, ListItem, ListItemText } from "@mui/material";
import React from "react";

export default function KeyData(props: { customer_key_data: any, name: string, cust_group_1: string }) {
    const { customer_key_data, name, cust_group_1 } = props;
    return (
        <React.Fragment>
            {customer_key_data && Object.entries(customer_key_data).length > 0 ? (
            <Card sx={{
                height: '100%', 
                maxHeight: 300, 
                // boxShadow: 'none', 
                borderRadius: '6px !important', 
                border: 0,
                boxShadow: 'none',
                // filter: (theme) =>`drop-shadow(0px 0px 1px ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.10)' : 'rgba(0,0,0,0.32)'})`,
                // boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)'
            }}>
                <CardHeader title={name} subheader={`Customer Group: ${cust_group_1}`} slotProps={{ title: { sx: { fontSize: '1rem !important' } }, subheader: { sx: { fontSize: '0.85rem !important' } } }} />
                <Divider />
                <CardContent sx= {{ height: 'auto' }}>
                    <List sx={{ width: '100%', maxWidth: '100%', overflowY: 'auto', padding: 0 }}>
                        <Grid container spacing={0} sx ={{ sm: 2, md: 3 }} >
                            {Object.entries(customer_key_data).map(([key, value]) => (
                                <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
                                    <ListItem alignItems="flex-start" sx={{ width: '100%', paddingLeft: 1, paddingBottom: 0 }}>
                                        <ListItemText
                                            id={key}
                                            primary={key}
                                            slotProps={{
                                                primary: {
                                                    sx: {
                                                        color: 'text.secondary',
                                                        fontWeight: 'normal',
                                                        fontSize: '0.75rem !important'
                                                    },
                                                }
                                            }}
                                            secondary={
                                                <React.Fragment>
                                                    <Typography
                                                        component="span"
                                                        variant="body2"
                                                        sx={{ color: 'text.primary', display: 'inline', fontSize: '0.7rem !important' }}
                                                    >
                                                        {`${value}`}
                                                    </Typography>
                                                </React.Fragment>
                                            }
                                        />
                                    </ListItem>
                                </Grid>
                            ))}
                        </Grid>
                    </List>
                    </CardContent>
                </Card>
            ) : (
                <Card 
                    sx={{
                        height: 'auto', maxHeight: 300, 
                        borderRadius: '6px !important', 
                        border: 0,
                        boxShadow: 'none',
                        // boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)'
                    }}>
                    <CardHeader title="Key Data" slotProps={{ title: { sx: { fontSize: '1rem !important' } } }} />
                    <Divider />
                    <CardContent>
                        <Typography variant="body1" sx={{ color: 'text.secondary', textAlign: 'center' }}>No data available</Typography>
                    </CardContent>
                </Card>
            )}
        </React.Fragment>
    );
}